import { connect } from 'react-redux';
import React from 'react';
import { renderKBInput, withReduxFormFieldProps } from 'components/formAdapters/reduxFormAdapters';
import { Field, reduxForm } from 'redux-form';
import { KBFormError,
KBButton } from
'components';

var SpaceSettingPrintPriceForm = class extends React.Component {constructor(props) {super(props);this.updateSpace = this.updateSpace.bind(this);}updateSpace(

  model) {
    const { updateCurrentSpace } = this.props;

    updateCurrentSpace(
    {
      settings: JSON.stringify({
        printer_settings: {
          print_price_setting: model } }) },



    {
      key: 'printer_settings' });


  }render()

  {
    const {
      fields: { A4_black_white, A4_colour, A3_black_white, A3_colour },
      error,
      submitting,
      handleSubmit } =
    this.props;
    return (
      <form onSubmit={handleSubmit(this.updateSpace)}>
        <KBFormError err={this.props.error} />
        <div className="kb-form-container" style={{ padding: 0 }}>
          <KBFormError err={error} />

          <div className="kb-row">
            <div className="kb-form-66">
              <Field name="A4_black_white" component={renderKBInput}
              className="kb-form-group kb-div-c48"

              title="A4（黑白）价格" />

              <Field name="A4_colour" component={renderKBInput}
              className="kb-form-group kb-div-c48"

              title="A4（彩色）价格"
              titleClass="label-rt" />

            </div>
          </div>
          <div className="kb-row">
            <div className="kb-form-66">
              <Field name="A3_black_white" component={renderKBInput}
              className="kb-form-group kb-div-c48"

              title="A3（黑白）价格" />

              <Field name="A3_colour" component={renderKBInput}
              className="kb-form-group kb-div-c48"

              title="A3（彩色）价格"
              titleClass="label-rt" />

            </div>
          </div>
          <div className="kb-row m-top">
            <KBButton
            className="certain-btn"
            type="submit"
            submitting={submitting}>

              保存
            </KBButton>
          </div>
        </div>
      </form>);

  }};


function mapStateToProps(state, props) {
  const setting = props.setting || {};
  const printerSettings = setting.printer_settings || {};
  let { A4_black_white, A4_colour, A3_black_white, A3_colour } =
  printerSettings.print_price_setting || {};
  return {
    initialValues: { A4_black_white, A4_colour, A3_black_white, A3_colour } };

}

function mapDispatchToProps(dispatch) {
  return {};
}

const LEGACY_FORM_FIELDS = [
  "A4_black_white",
  "A4_colour",
  "A3_black_white",
  "A3_colour"
];

const formConfig = {
  form: 'SpaceSettingPrintPriceForm',
  touchOnBlur: false };


export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(withReduxFormFieldProps('SpaceSettingPrintPriceForm', LEGACY_FORM_FIELDS)(SpaceSettingPrintPriceForm)));
